<template>
  <div class="container">
    <div class="container-content">
      <div class="content-title">心理测评</div>
      <div class="query">
        <MyForm class="search-form" :formOptions="queryForm" :inline="true"></MyForm>
      </div>
      <div class="table">
        <MyTable :table-options="tableOptions" border max-height="65vh"
          @selection-change="(val) => (multipleSelection = val)">
          <template #cover="{ row }">
            <img v-if="row.cover" :src="row.cover" alt="" class="cover_img" @click="click_cover(row.cover)" />
          </template>
          <template #issueState="{ row }">
            <el-switch v-model="row.issueState" @change="handleIsEnableChange(row.id, row.issueState)" />
          </template>
          <template #handler="{ row }">
            <el-button style="color: #6fcaf7" icon="View" link @click="click_look(row)">查看问卷</el-button>
            <el-button style="color: #6fcaf7" icon="EditPen" link @click="click_edit(row)">修改问卷</el-button>
            <el-button style="color: #6fcaf7" icon="Edit" link @click="handleEdit(row)">编辑</el-button>
            <ConfirmButton style="color: #6fcaf7" icon="Delete" link @confirm="handleDelete(row)">删除</ConfirmButton>
          </template>
        </MyTable>
        <MyPagination :params="queryParams" :total="total" @get-list="getList" ref="pagination" />
      </div>
    </div>
    <!-- 新增 -->
    <Dialog v-model="addVisible" :title="title" top="5vh" @closed="clearForm" width="40%">
      <el-form class="addForm" :model="formData" label-width="auto">
        <el-form-item label="封面:">
          <ImgUpload v-model="formData.cover" />
          <div class="tip" style="margin-left: 20px;">(建议上传690*150px的图片)</div>
        </el-form-item>
        <el-form-item label="分类:">
          <el-select v-model="formData.keyId" placeholder=""
            @change="(val) => { formData.keyName = classificationList.find(item => item.id === val)?.name || '' }">
            <el-option v-for="item in classificationList" :key="item.id" :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="submit-buttons">
        <el-button plain @click="addVisible = false">取消</el-button>
        <MyButton @click="click_confirm">确定</MyButton>
      </div>
    </Dialog>
    <!-- 图片预览 -->
    <Dialog v-model="dialogImgVisible" title="图片预览" top="5vh">
      <img :src="dialogImageUrl" alt="Preview Image" style="width: 100%" />
    </Dialog>

    <Questionnaire v-model="questionnaireVisible" :type="type" :qid="qid" @closed="handleClosed" />
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import MyTable from "@/components/Global/MyTable.vue";
import MyButton from "@/components/Global/MyButton.vue";
import MyPagination from "@/components/Global/MyPagination.vue";
import ConfirmButton from "@/components/Common/ConfirmButton.vue";
import ImgUpload from "@/components/Common/ImgUpload.vue";
import Questionnaire from "@/components/Questionnaire.vue";
import dictionary from "@/api/dict.js";
import questionnaireApi from "@/api/questionnaire.js";
import { dayjs, ElMessage, ElMessageBox } from "element-plus";

const dialogImgVisible = ref(false); //预览图片dialog
const dialogImageUrl = ref(""); //预览图片地址
// 图片预览
const click_cover = (url) => {
  dialogImageUrl.value = url;
  dialogImgVisible.value = true;
};

//分类
const classificationList = ref([]); //分类列表
const getClassificationList = () => {
  dictionary.getList({
    Code: 'question',
    SkipCount: 0,
    MaxResultCount: 1000,
  }).then(res=>{
    classificationList.value = res.data.items;
  });
};
getClassificationList();
// 搜索
const queryForm = reactive({
  itemList: [
    {
      type: "input",
      label: "关键字：",
      prop: "QuestionnaireName",
    },
    {
      type: "Button",
      value: "查询",
      attrs: {
        icon: "Search",
      },
      events: {
        click(formData) {
          Object.assign(queryParams, formData);
        },
      },
    },
    {
      type: "Button",
      value: "新增",
      attrs: {
        icon: "Plus",
      },
      events: {
        click(formData) {
          addVisible.value = true;
          title.value = "新增心理测评";
          type.value = 1;
        },
      },
    },
    {
      type: "Button",
      value: "删除",
      attrs: {
        icon: "DeleteFilled",
        style: {
          marginRight: "100px",
        },
      },
      events: {
        click(formData) {
          ElMessageBox.confirm("确定删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            if (!multipleSelection.value.length)
            return ElMessage.warning("请选择问卷");
            await Promise.all(multipleSelection.value.map(item => questionnaireApi.delete(item.id)));
            await getList();
            ElMessage.success("删除成功");
          }).catch(() => {})
        },
      },
    },
  ],
});

// 表格
const tableOptions = reactive({
  colList: [
    { type: "selection", width: 50 },
    { type: "index", label: "序号", width: 60 },
    { type: "slot", label: "封面", slot_name: "cover",minWidth: 100 },
    { label: "问卷", prop: "questionnaireName" },
    { label: "分类", prop: "keyName" },
    { label: "创建时间", prop: "creationTime" },
    { type: "slot", label: "是否启用", slot_name: "issueState" },
    { type: "slot", slot_name: "handler", label: "操作", width: 300 },
  ],
  tableData: [],
});

// 分页
const queryParams = reactive({
  QuestionnaireName: "",
});
const pagination = ref();
const total = ref(0);
const getList = async (params=pagination.value?.getList_params) => {
  let res = await questionnaireApi.getList(params);
  const { items, totalCount } = res.data;
  tableOptions.tableData = items.map(item=>{
    item.creationTime = dayjs(item.creationTime).format("YYYY-MM-DD HH:mm:ss");
    return item;
  });
  total.value = totalCount;
};

const questionnaireVisible = ref(false); //问卷弹框
const type = ref(1); //问卷的类型
const qid = ref(""); //问卷id
const multipleSelection = ref([]); //表格勾选项

// 新增心理测评
const title = ref("新增心理测评");
const addVisible = ref(false);
const formData = ref({
  cover: "",
  keyId: "",
  keyName: "",
  issueState: false,
});

// 新增心理测评 确认按钮
const click_confirm = () => {
  if(formData.value.id) {
    questionnaireApi.editQuestionnaire(formData.value).then((res) => {
      addVisible.value = false;
      getList();
      ElMessage.success("修改成功");
    });
  }else{
    questionnaireApi.addQuestionnaire(formData.value).then((res) => {
      addVisible.value = false;
      qid.value = res.data.id;
      questionnaireVisible.value = true;
    })
  }
};

// 问卷关闭的回调
const handleClosed = () => {
  getList();
};

// 清空表单值
const clearForm = () => {
  formData.value = {
    cover: "",
    keyId: "",
    keyName: "",
    IssueState: false,
  }
};

const handleIsEnableChange = (id, issueState) => {
  questionnaireApi.updatePublishStatus(id, issueState).then(() => {
    ElMessage.success("操作成功");
  });
};

const click_look = (row) => {
  type.value = 3;
  qid.value = row.qId;
  questionnaireVisible.value = true;
}

const click_edit = (row) => {
  type.value = 2;
  qid.value = row.qId;
  questionnaireVisible.value = true;
};

// 编辑
const handleEdit = (row) => {
  addVisible.value = true;
  title.value = "编辑心理测评";
  formData.value = { ...row };
};

// 删除
const handleDelete = (row) => {
  questionnaireApi.delete(row.id).then(() => {
    ElMessage.success("删除成功");
    getList();
  });
};
</script>

<style lang="scss" scoped>
.container {
  .cover_img {
    width: 100px;
    height: 70px;
    border-radius: 8px;
    cursor: pointer;
  }
  .upload-box {
    width: 100px;
    height: 100px;
    border: 1px solid #dfdfdf;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    .icon-size {
      width: 30px;
      height: 25px;
    }
  }
}
.addForm{
  padding: 20px 40px;
}
</style>
